let mainList = []

const autoCompleteHiddenSelector = "[data-autocomplete-target='hidden']"

const TestScheduleListManage = (data, type, e) => {

  switch(type) {
    case "initial":
      return initialTestScheduleMap(data)

    case "add":
      return addScheduleToScheduleList(e, data)

    case "remove":
      return removeStsIdsFromScheduleList(data)

    case "find":
      return findScheduleFromScheduleList(e, data)
    
    case "removeMainList":
      return removeMainList()

    case "filter":
      return filter(e, data)
    
    case "isExistsTest":
      return isExistsTest(e,data)
      
    default:
      return mainList
  }

}

function removeMainList(){
  mainList.length = 0
  mainList = []
}

function initialTestScheduleMap(targets){
  for (let index = 0; index < targets.length; index++) {
    const item = targets[index];
    let obj = {}
    let dataset = item.dataset
    if (!dataset.testScheduleId){
      return
    }
    obj['id'] = dataset.id
    obj['tsId'] = parseInt(dataset.testScheduleId)
    obj['stsId'] = parseInt(dataset.stsId)
    obj['specimenId'] = parseInt(dataset.specimenId)      
    mainList.push(obj)
  }
  filledTestScheduleIds()
  return mainList
}


function addScheduleToScheduleList(e, data){  
  let stsData = data.sts
  for (let index = 0; index < stsData.length; index++) {
    const element = stsData[index];
    let obj = {}
    obj['id'] = e.target.dataset.id
    obj['tsId'] = element.test_schedule_id
    obj['stsId'] = element.id
    obj['specimenId'] = element.specimen_id
    mainList.push(obj)
  }
  filledTestScheduleIds()
  return mainList
}

function removeStsIdsFromScheduleList(currentSchItems){
  for (let index = 0; index < currentSchItems.length; index++) {
    const willDelete = currentSchItems[index];
    const objWithIdIndex = mainList.findIndex(
      (obj) => obj.id == willDelete.id && obj.tsId == willDelete.tsId && obj.stsId == willDelete.stsId && obj.specimenId == willDelete.specimenId
    );
    if (objWithIdIndex > -1) {
      mainList.splice(objWithIdIndex, 1);
    }
  }
  filledTestScheduleIds()
  return mainList
}

function findScheduleFromScheduleList(e, specimenIds){
  const tsId = getTsID(e)
  if (!tsId) {
    console.warn("There is a problem. You already deleted this test or try reselect a test and specimens!");
    return
  }

  let currentStsIds = []
  let currentItems = []
  for (let index = 0; index < mainList.length; index++) {
    const item = mainList[index];
    if  (item['id'] == e.target.dataset.id && specimenIds.indexOf(parseInt(item['specimenId'])) >= 0 && item['tsId'] && tsId == item['tsId']){
      currentStsIds.push(parseInt(item['stsId']))
      currentItems.push(item)
    }
  }
  return [currentStsIds, currentItems]
}

function filter(e, specimenIds) {
  const tsId = getTsID(e)
  if (!tsId) {
    console.warn("There is a problem. You already deleted this test or try reselect a test and specimens!");
    return
  }
  let listedSpecimenIds = String(specimenIds).split(",");
  for (let index = 0; index < mainList.length; index++) {
    const item = mainList[index];
    if (specimenIds.indexOf(parseInt(item['specimenId'])) >= 0 && item['tsId'] && tsId == item['tsId']) {
      listedSpecimenIds = listedSpecimenIds.filter(function (id) {
        return id !== String(item['specimenId'])
      })
    }
  }
  return listedSpecimenIds.join(",")
}

function isExistsTest(e, specimenIds) {
  if (!specimenIds){
    console.warn("There is a problem. You already deleted this test or try reselect a test and specimens!");
    return true
  }

  const tsId = getTsID(e)
  if (!tsId) {
    console.warn("There is a problem. You already deleted this test or try reselect a test and specimens!");
    return true
  }

  for (let index = 0; index < mainList.length; index++) {
    const item = mainList[index];
    if (specimenIds.indexOf(parseInt(item['specimenId'])) >= 0 && item['tsId'] && tsId == item['tsId']) {
      return true
    }
  }
  return false
}

function findTargetByQuerySelector(selector, e) {
  const dataId = e.target.dataset.id
  return document.querySelector(`${selector}[data-id="${dataId}"]`)
}

function getTsID(e) {
  const testScheduleIdTarget = findTargetByQuerySelector(autoCompleteHiddenSelector, e)
  return testScheduleIdTarget ? testScheduleIdTarget.value : ""
}

function filledTestScheduleIds() {
  const set = new Set();
  for (let index = 0; index < mainList.length; index++) {
    const element = mainList[index];
    set.add(element.tsId)
  }
  const item = document.getElementById('test_schedule_ids')
  if (item) {
    item.value = [...set]
  }
}


export default TestScheduleListManage